import React, { useEffect } from 'react';
import moment from 'moment';

import { MenuBar, MenuBarLink, MenuBarItem } from './ReportsMenu.styles';
import { DatePicker } from '../DatePicker/DatePicker';
import { MediaMatcher } from 'components/MediaMatcher/MediaMatcher';
import { HideElements, PATH_REPORTS, MOMENT_DATE } from 'common/constants';
import { useRematchDispatch, useRematchSelector } from 'models/rematchStore';
import { useNavigate, useLocation } from 'react-router-dom';
import qs from 'query-string';

const dateString = (date) => moment(date).format(MOMENT_DATE);
export const ReportsMenuView = ({ isOutsideRange, getUrlWithDay, selectedParkData }) => {
    const dispatch = useRematchDispatch();
    const location = useLocation();
    const { pathname, search } = location;
    const navigate = useNavigate();
    const menuBar = useRematchSelector((state) => state.menuBar);
    const { selectedPark } = useRematchSelector((state) => state.appData);
    const selectParkName = selectedPark.toLowerCase();
    const reportPageURL = `/${selectParkName}/reports`;
    const { hideUiElements = [] } = selectedParkData;
    const selectedDate = moment(menuBar.selectedDate);

    useEffect(() => {
        if (!pathname) return;

        const query = qs.parse(search, { ignoreQueryPrefix: true });

        if (pathname.includes(PATH_REPORTS)) {
            dispatch.menuBar.checkParamsAndSetUrl({ payload: { search, pathname, navigate } });

            if (query.day) {
                const parsedDate = moment(query.day, MOMENT_DATE, true);
                dispatch.menuBar.selectDate({
                    payload: {
                        selectedDate: parsedDate,
                        pathname,
                    },
                });
            }
        }
    }, [location]);

    const onDateSelectHandler = (selectedDatePickerDate) => {
        dispatch.menuBar.selectDate({
            payload: {
                selectedDate: moment(selectedDatePickerDate, MOMENT_DATE, true),
                pathname,
            },
        });
        const queryString = qs.stringify({
            day: dateString(selectedDatePickerDate),
        });
        navigate({
            search: `?${queryString}`,
        });
    };

    return (
        <MenuBar>
            <MenuBarLink to={getUrlWithDay(reportPageURL, 'overview', selectedDate)} data-testid="overview-link">
                Overview
            </MenuBarLink>
            {!hideUiElements.includes(HideElements.reportsPerformanceLink) && (
                <MenuBarLink
                    to={getUrlWithDay(reportPageURL, 'performance', selectedDate)}
                    data-testid="performance-link">
                    Performance
                </MenuBarLink>
            )}
            {!hideUiElements.includes(HideElements.reportsPerformanceLink) && (
                <MenuBarLink
                    to={getUrlWithDay(reportPageURL, 'maintenance', selectedDate)}
                    data-testid="maintenance-link">
                    Maintenance
                </MenuBarLink>
            )}
            <MenuBarItem flex="1" justifyContent="flex-end">
                <MediaMatcher maxWidth="tablet">
                    {(matches) => (
                        <DatePicker
                            date={selectedDate}
                            selectDate={onDateSelectHandler}
                            isOutsideRange={isOutsideRange}
                            displayFormat={matches.maxWidth ? 'MMM D, YYYY' : 'MMMM D, YYYY'}
                            readOnly={matches.maxWidth}
                        />
                    )}
                </MediaMatcher>
            </MenuBarItem>
        </MenuBar>
    );
};
